import React from 'react';
import { HeroSection } from './HeroSection';
import { PainSection } from './PainSection';
import { RulesSection } from './RulesSection';
import { OfferSection } from './OfferSection';
import { BonusesSection } from './BonusesSection';
import { FaqSection } from './FaqSection';
import { FinalCtaSection } from './FinalCtaSection';
import { SectionDivider } from './ui/SectionDivider';
import { RecentPurchaseToast } from './RecentPurchaseToast';
export function SalesPage() {
  return <main className="min-h-screen w-full bg-brand-bg text-brand-text selection:bg-brand-gold selection:text-brand-bg" data-id="element-726">
      <HeroSection data-id="element-727" />
      <SectionDivider data-id="element-728" />

      <PainSection data-id="element-729" />
      <SectionDivider data-id="element-730" />

      <RulesSection data-id="element-731" />
      <SectionDivider data-id="element-732" />

      <OfferSection data-id="element-733" />
      <SectionDivider data-id="element-734" />

      <BonusesSection data-id="element-735" />
      <SectionDivider data-id="element-736" />

      <FaqSection data-id="element-737" />
      <SectionDivider data-id="element-738" />

      <FinalCtaSection data-id="element-739" />

      <RecentPurchaseToast data-id="element-740" />
    </main>;
}